import isString from "lodash/isString";
import { getUserInfoApi } from "@/services/user";
import useUserStore from "@/stores/useUserStore";
import useAppStore from "@/stores/useAppStore";

export const getUserInfo = async (token: string) => {
  const { initAppStore } = useAppStore.getState();
  if (!isString(token)) {
    return false;
  }

  initAppStore(token);

  const res = await getUserInfoApi();

  if (!res.success) {
    return false;
  }

  const { setUserInfo } = useUserStore.getState();

  setUserInfo(res.model);

  return true;
};
